import { forwardRef } from "react";
import classNames from "classnames";
import { Division } from "@ir/ui";

interface PageFooterProps {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const PageFooter = forwardRef<HTMLDivElement, PageFooterProps>(({ children, className, style }, ref) => {
  const mainContentFooterClass = classNames("main-content-footer", "px-3", "py-2", className);
  return (
    <Division className={mainContentFooterClass} style={style} ref={ref}>
      {children}
    </Division>
  );
});

export default PageFooter;
